"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextChoiceStack = void 0;
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
function TextChoiceStack({ children, ...rest }) {
    return (react_1.default.createElement(material_1.Stack, { direction: {
            xs: 'column',
            sm: 'row',
        }, gap: {
            xs: '24px',
            sm: '16px',
        }, sx: {
            width: '100%',
            justifyContent: 'center',
        }, ...rest }, children)
    // <div
    //   className="flex flex-col sm:flex-row gap-[24px] sm:gap-[16px] justify-center w-[100%]"
    //   {...rest}
    // >
    //   {children}
    // </div>
    );
}
exports.TextChoiceStack = TextChoiceStack;
